'use strict';

var Model = Backbone.Model;
var ModelProto = Model.prototype;
var parseSetMethodArgs = require('../../modules/utils/model.utils').parseSetMethodArgs;
var NUMBER_PROP = 'number';

var calculateChangeSignEvent = function(previous, current) {
    var previousPositive = previous > 0;
    if (Odigeo._.isUndefined(current)) {
        return '';
    } else if (!previousPositive && current > 0) {
        return 'change:sign:positive';
    } else if (previousPositive && current === 0) {
        return 'change:sign:zero';
    }
    return '';
};

module.exports = Model.extend({
    parse: function(number) {
        return Odigeo._.isObject(number) ? Odigeo._.pick(number, [NUMBER_PROP]) : Odigeo._.zipObject([NUMBER_PROP], [number]);
    },
    getNumber: function() {
        return this.get(NUMBER_PROP);
    },
    set: function() {
        var args = parseSetMethodArgs(arguments);
        var attrs = Odigeo._.pick(args[0], 'number');
        var options = args[1];
        var num = attrs.number;
        var previous = this.getNumber();
        var event = calculateChangeSignEvent(previous, num);
        var result = ModelProto.set.call(this, attrs, options);
        if (event) {
            this.trigger(event);
        }
        return result;
    },
});
